import { apiGet } from "service/api";
import { setCurrentUserData } from "service/mapper";
import { LIST, panelApi, runQuery } from "./panelApi";

/**
 * Gives the user a primary district: the API's one, or else the first of
 * their districts (the district pages open that one).
 */
export const withPrimaryDistrict = (user) => {
  if (user.primary_district_id || !user.districts?.length) return user;
  return { ...user, primary_district_id: user.districts[0].id };
};

/**
 * The signed-in user (RTK Query). ProtectedRoute loads it after login;
 * components read it with `useSelector(getUserStoreData)`.
 */
export const userEndpoints = panelApi.injectEndpoints({
  endpoints: (build) => ({
    getCurrentUser: build.query({
      queryFn: () =>
        runQuery(async () => withPrimaryDistrict(setCurrentUserData((await apiGet("_accessToken")).data))),
      providesTags: [LIST.currentUser],
    }),
  }),
});

export const { useGetCurrentUserQuery } = userEndpoints;
